import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

const TEST_ID = 'caps-lock-icon';

/**
 * An Icon whose SVG shows a lock with an "A" on it
 * @param IconProps
 */
export const CapsLockIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 24 24"
            className={fillStyles}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12 2C15.3137 2 18 4.68629 18 8V9.15039C18.2826 9.21232 18.5543 9.302 18.8164 9.43555C19.5689 9.81902 20.181 10.4311 20.5645 11.1836C20.8117 11.669 20.9102 12.186 20.9561 12.748C21.0003 13.2892 21 13.9538 21 14.7588V16.2412C21 17.0462 21.0003 17.7108 20.9561 18.252C20.9102 18.814 20.8117 19.331 20.5645 19.8164C20.181 20.5689 19.5689 21.181 18.8164 21.5645C18.331 21.8117 17.814 21.9102 17.252 21.9561C16.7108 22.0003 16.0462 22 15.2412 22H8.75879C7.95381 22 7.28925 22.0003 6.74805 21.9561C6.18599 21.9102 5.6689 21.8117 5.18359 21.5645C4.43107 21.181 3.81901 20.5689 3.43555 19.8164C3.18827 19.331 3.08987 18.814 3.04395 18.252C2.99973 17.7108 2.99999 17.0462 3 16.2412V14.7588C2.99999 13.9538 2.99973 13.2892 3.04395 12.748C3.08987 12.186 3.18827 11.669 3.43555 11.1836C3.81901 10.4311 4.43108 9.81902 5.18359 9.43555C5.44569 9.302 5.7174 9.21233 6 9.15039V8C6 4.68629 8.68629 2 12 2ZM12.0332 11.1191C11.3802 11.1192 10.973 11.4284 10.7324 12.0986L8.47559 18.2451C8.40117 18.4569 8.36139 18.6517 8.36133 18.7949C8.36133 19.2931 8.69911 19.6082 9.23731 19.6084C9.69547 19.6084 9.95385 19.3797 10.1143 18.8301L10.5498 17.541H13.5342L13.9697 18.8467C14.1244 19.3852 14.3822 19.6084 14.8691 19.6084C15.3731 19.6083 15.7334 19.2703 15.7334 18.7949C15.7334 18.6232 15.7051 18.4684 15.625 18.2451L13.3564 12.0928C13.1101 11.417 12.7091 11.1191 12.0332 11.1191ZM12.0391 12.8145L13.1328 16.2002H10.9277L11.999 12.8145H12.0391ZM12 4C9.79086 4 8 5.79086 8 8V9.00195H16V8C16 5.79086 14.2091 4 12 4Z" />
        </svg>
    );
};

CapsLockIcon.TEST_ID = TEST_ID;
